import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Navbar, Nav, NavDropdown, Container, Button } from 'react-bootstrap';
import { FiUserPlus } from 'react-icons/fi';
import { useAuth } from '../context/AuthContext';

const COLORS = {
  bg: 'rgba(11, 15, 25, 0.88)',
  border: 'rgba(255, 255, 255, 0.08)',
  accent: '#4f8cff',
  text: '#ffffff',
  muted: '#9aa4bf',
};

const NavBar = () => {
  const { user, logout, authLoaded } = useAuth();

  const navigate = useNavigate();
  const [expanded, setExpanded] = useState(false);

  const closeMenu = () => setExpanded(false);

  // ================= LOGIN CHECK =================
  const isLoggedIn = !!user?._id || !!user?.email;

  const handleLogout = async () => {
    await logout();
    closeMenu();
    navigate('/login');
  };

  if (!authLoaded) {
    return (
      <Navbar style={{ background: COLORS.bg }}>
        <Container>
          <Navbar.Brand style={{ color: COLORS.text }}>
            Loading…
          </Navbar.Brand>
        </Container>
      </Navbar>
    );
  }

  return (
    <>
      {/* White hamburger icon */}
      <style>
        {`
          .navbar-toggler {
            border: none;
          }
          .navbar-toggler:focus {
            box-shadow: none;
          }
          .navbar-toggler-icon {
            background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='rgba(255,255,255,1)' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e");
          }
        `}
      </style>

      <Navbar
        expand="lg"
        expanded={expanded}
        onToggle={() => setExpanded(prev => !prev)}
        sticky="top"
        style={{
          background: COLORS.bg,
          backdropFilter: 'blur(14px)',
          borderBottom: `1px solid ${COLORS.border}`,
          padding: '0.65rem 0',
        }}
      >
        <Container>

          {/* BRAND */}
          <Navbar.Brand
            as={Link}
            to="/"
            onClick={closeMenu}
            style={{
              fontWeight: 800,
              color: COLORS.text,
            }}
          >
            Customer<span style={{ color: COLORS.accent }}>Portal</span>
          </Navbar.Brand>

          <Navbar.Toggle aria-controls="main-navbar" />

          <Navbar.Collapse id="main-navbar" className="justify-content-end">

            <Nav className="align-items-lg-center gap-lg-3 gap-2 mt-3 mt-lg-0">

              {/* ADMIN MENU */}
              {user?.isAdmin && (
                <NavDropdown
                  title={
                    <span
                      style={{
                        padding: '6px 14px',
                        borderRadius: '999px',
                        fontSize: '0.75rem',
                        fontWeight: 700,
                        background: COLORS.accent,
                        color: '#fff',
                      }}
                    >
                      ADMIN
                    </span>
                  }
                  menuVariant="dark"
                >
                  <NavDropdown.Item as={Link} to="/admin/customers" onClick={closeMenu}>
                    Customers
                  </NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/addproduct" onClick={closeMenu}>
                    Add Product
                  </NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/productlist" onClick={closeMenu}>
                    Edit Products
                  </NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/admin/orders" onClick={closeMenu}>
                    Orders
                  </NavDropdown.Item>
                </NavDropdown>
              )}

              {/* AUTH */}
              {user ? (
                <>
                  <span
                    style={{
                      fontSize: '0.85rem',
                      color: COLORS.muted,
                    }}
                  >
                    Hi, <strong style={{ color: COLORS.text }}>{user.name}</strong>
                  </span>

                  <Button
                    size="sm"
                    variant="outline-light"
                    onClick={handleLogout}
                    style={{
                      borderRadius: '999px',
                      padding: '6px 14px',
                    }}
                  >
                    Logout
                  </Button>
                </>
              ) : (
                <Nav.Link
                  as={Link}
                  to="/login"
                  onClick={closeMenu}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '10px',
                    fontWeight: 600,
                    color: COLORS.text,
                  }}
                >
                  <span
                    style={{
                      width: 34,
                      height: 34,
                      borderRadius: '50%',
                      border: `1px solid ${COLORS.accent}`,
                      display: 'grid',
                      placeItems: 'center',
                    }}
                  >
                    <FiUserPlus size={16} />
                  </span>
                  Sign in
                </Nav.Link>
              )}

            </Nav>
          </Navbar.Collapse>

        </Container>
      </Navbar>
    </>
  );
};

export default NavBar;